import React, { RefObject, useEffect } from 'react';

type HandledEvents = ['touchstart', 'mousedown'];
type HandledEventsType = HandledEvents[number];
type PossibleEvent = {
  [Type in HandledEventsType]: HTMLElementEventMap[Type];
}[HandledEventsType];
type EventHandler = (e: PossibleEvent) => void;

//use this method to trigger event  on click outside a certain element (

export function useOnClickOutside(ref: RefObject<HTMLElement>, handler: EventHandler): void {
  useEffect(() => {
    const listener = (event: PossibleEvent) => {
      // Do nothing if clicking ref's element or descendent elements
      if (!ref.current || ref.current.contains(event.target as Node)) {
        return;
      }
      handler(event);
    };
    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);
    return () => {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }),
    [ref, handler];
}
